var dropdownTimeout;
var selectIsOpen;

jQuery(document).ready(commonInit);
jQuery(window).on('load', setupPageLoadAnchors);

function commonInit(){
	
	setupHeader();
	setupSearch();
	setupDesktopMenu();
	setupMobileMenu();
	setupModals();
	setupHomepageAnchors();
	setupAccordion();
	setupCalendar();
	setupForms();
	setupFakeDropdowns(jQuery(".tribe-bar-views-select"));
	setupTestimonialSliders();
	setupFooterLogoRanch();
	
}

function setupHeader(){
	
	jQuery(window).scroll(function(){
		
		scrollEvents();
		
	});
	
	scrollEvents();
	
}

function scrollEvents(){
	
	if(jQuery(window).scrollTop() > 100)
		jQuery("html").addClass("small-header sidebar-in");
	else
		jQuery("html").removeClass("small-header");
	
}

function setupSearch(){
	
	jQuery("#search-icon").click(function(){
		
		jQuery("html").toggleClass("global-search");
		jQuery("#global-search-input").focus();
		
	});
	
	jQuery("#global-search .close").click(function(){
		
		jQuery("html").removeClass("global-search");
		jQuery("#global-search-input").val("");
		
		return false;
		
	});
	
}

function setupDesktopMenu(){
	
	var megaCounter = 0;
	
	jQuery("#menu-main > li > ul.sub-menu").each(function(){
		
		var currentContainer = "mega-container-" + megaCounter;
		var parentListID = jQuery(this).parent().attr("id");
		
		jQuery("#mega .right").append("<div class='mega-container' data-parent-list='"+parentListID+"' id='"+currentContainer+"'></div>");
		
		megaCounter++;
		
		var listItemCounter = 0;
		
		jQuery(" > li", this).each(function(){
			
			var listItem = jQuery(this);
			
			if(listItem.hasClass("new-column") || listItemCounter == 0)
				jQuery("#mega .right #"+currentContainer).append("<ul class='list-column'></ul>");
			
			listItem.detach().appendTo(jQuery("#"+currentContainer+" > ul:last-child"));
			
			listItemCounter++;
			
		});

	});
	
	jQuery("#menu-main > li.menu-item-has-children").hover(function(){
		
		clearTimeout(dropdownTimeout);
		hideDropdown();
		
		var id = jQuery(this).attr("id");
		
		jQuery(this).addClass("active");
		jQuery("#mega").show();
		jQuery(".mega-container[data-parent-list='"+id+"']").css("display", "flex");
		
	}, function(){
		
		dropdownTimeout = setTimeout(hideDropdown, 200);
		
	});
	
	jQuery("#mega").hover(function(){
		
		clearTimeout(dropdownTimeout);
		jQuery(this).show();
		
	}, function(){
		
		dropdownTimeout = setTimeout(hideDropdown, 200);
		
	});
	
}

function hideDropdown(){
	
	jQuery("#mega, .mega-container").hide();
	jQuery("#menu-main > li.active").removeClass("active");
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({
		
		navbars: {
        content: [ "searchfield" ]
     },
     searchfield: {
        search: false,
        placeholder: "Search specific needs"
     }

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}, searchfield: {
        form: {
           name: "",
           method: "post"
        },
        input: {
           name: "s"
        },
        submit: true
     }
		
	});
	
}

function setupModals(){
	
	jQuery(".modal-youtube").modalVideo();
	jQuery(".modal-vimeo").modalVideo({channel:'vimeo'});
	
}

function setupHomepageAnchors(){
	
	jQuery("#homepage-hero a.anchor-button").click(function(){
		
		scrollToAnchor(jQuery(this).attr("href"));
		
		return false;
		
	});
	
}

function scrollToAnchor(href){
	
    jQuery('html,body').animate({scrollTop: jQuery(href).offset().top - 150}, 1000);
    
}

function setupAccordion(){
	
	jQuery(".accordion h3").click(function(){
		
		var selectedHeader = jQuery(this);
		var closeOnly = false;
		
		if(selectedHeader.hasClass("open"))
			closeOnly = true;
		
		var parent = selectedHeader.parents(".accordion");
		var previousSelectedHeader = jQuery(".open", parent);	
		
		jQuery(" + div", previousSelectedHeader).removeClass("active").slideToggle(300);
		
		previousSelectedHeader.removeClass("open");

		if(!closeOnly){
			selectedHeader.toggleClass("open");
			jQuery(" + .content", this).addClass("active").slideToggle(300);
		}
		
	});
	
}

function setupCalendar(){
	
	jQuery("#calendar-categories").detach().appendTo('#tribe-bar-views').show();
	
	calendarCategoryAlign();
	
	jQuery("#calendar-categories input").change(function(){
		
		var value = jQuery(this).val();
		
		if(this.checked)
			jQuery("#tribe-events-content .tribe-events-category-"+value).removeClass("hide");
		else
			jQuery("#tribe-events-content .tribe-events-category-"+value).addClass("hide");
		
	});
	
	if(typeof tribe_ev !== 'undefined'){
	
		jQuery(tribe_ev.events).on('tribe_ev_ajaxSuccess' , function() {
			
			calendarCategoryAlign();
			
		});
	
	}
	
}

function calendarCategoryAlign(){
	
	jQuery("#calendar-categories input").each(function(){
		
		if(!this.checked)
			jQuery("#tribe-events-content .tribe-events-category-"+jQuery(this).val()).addClass("hide");
		
	});
	
}

function setupPageLoadAnchors(){
	
	var anchor = getUrlVars()["anchor"];
	
	if(jQuery(window).width() > 1075)
		var headerHeight = 111;
	else
		var headerHeight = 83;

	if(usedDonationForm)
		jQuery('html,body').animate({scrollTop: jQuery("#gform_wrapper_1").offset().top - 150}, "slow");
	else if(anchor && jQuery("section[data-anchor='"+anchor+"']").length > 0)
		jQuery('html,body').animate({scrollTop: jQuery("section[data-anchor='"+anchor+"']").offset().top - headerHeight}, "slow");
	
}

function setupFakeDropdowns(element){
	
	var counter = 0;
	
	element.each(function(){
		
		jQuery(this).hide();
		
		var id;
		
		if(jQuery(this).attr("id"))
			id = jQuery(this).attr("id") + "_fake";
		else
			id = "dropdown_"+counter;
		
		jQuery("<div id='"+id+"' class='fake-select'><p class='selected'>Default</p><ul class='simple-list'></ul></div>").insertAfter(jQuery(this));
		
		var optionCounter = 0;
		var firstOption;
		
		jQuery("option", this).each(function(){
			
			if(jQuery(this).attr("selected"))
				jQuery("#"+id+" ul").append("<li class='active' data-value='"+jQuery(this).attr("value")+"'>"+jQuery(this).html()+"</li>");
			else
				jQuery("#"+id+" ul").append("<li data-value='"+jQuery(this).attr("value")+"'>"+jQuery(this).html()+"</li>");
			
			if(jQuery(this).attr("selected"))
				firstOption = jQuery(this).html();
			
			optionCounter++;
			
		});
		
		jQuery("#"+id+" p").html(firstOption);
		
		jQuery("#"+id).click(function(){
			
			if(jQuery(this).hasClass("active")){
				
				jQuery(this).removeClass("active");
				
				selectIsOpen = false;
				
			}else{
				
				jQuery(this).addClass("active");
				
				setTimeout(dropBoxDelay, 5);
				
			}		
			
		});
		
		jQuery("#"+id+" li").click(function(){
			
			jQuery(this).siblings(".active").removeClass("active");
			jQuery(this).addClass("active");
			
			jQuery(this).parent().siblings("p").html(jQuery(this).html());
			
			jQuery("option:selected", jQuery(this).parents(".fake-select").prev("select")).removeAttr("selected");
			jQuery("option[value='"+jQuery(this).attr("data-value")+"']", jQuery(this).parents(".fake-select").prev("select")).attr("selected", "selected");
			
			element.trigger('change');
	
		});

		counter++;
		
	});
	
	jQuery(document).click(function(){
		
		if(selectIsOpen){
			
			jQuery(".fake-select").removeClass("active");
			
			selectIsOpen = false;
			
		}
		
	});

}

function setupForms(){
	
	jQuery(".ginput_card_expiration_container select").each(function(){
		
		jQuery(this).wrap("<div class='select-container'></div>").css("visibility", "visible");
		
	});
	
	jQuery(".dollar .gfield_radio input[type='radio']").change(function(){
		
		jQuery(".dollar .gfield_radio input[type='text']").val("Other");
		
		if(jQuery(this).val() != "gf_other_choice")
			updateDonateTotal(jQuery(this));
		
	});
	
	jQuery('.dollar input[type="text"]').on('input', function(){

		updateDonateTotal(jQuery(this));
		
	});
	
	jQuery('.gift-interval input[type="radio"]').change(function(){
		
		if(jQuery(".dollar .gfield_radio input[type='radio']:checked").val() != "gf_other_choice")
			updateDonateTotal(jQuery(".dollar .gfield_radio input[type='radio']:checked"));
		else
			updateDonateTotal(jQuery(".dollar .gfield_radio input[type='text']"));
		
	});
	
	jQuery(".dollar input[value='gf_other_choice'] + input").focus(function(){
		
		if(jQuery(this).val() != "")
			return false;
		
		jQuery(".ginput_total").html("$0.00");
		jQuery(".ginput_container_total > input").val(0);
		jQuery(".ginput_container_product_price > input").val(0);
		
	});

	setTimeout(updateDonateTotalOnLoad, 100);
	
}

function updateDonateTotalOnLoad(){
	
	jQuery(".ginput_total").html(jQuery(".ginput_container_product_price > input").val());
	
}

function updateDonateTotal(element){
	
	if(parseFloat(element.val()).toFixed(2) == "NaN")
		return false;
	
	if(jQuery(".gift-interval input:checked").val() == "Monthly gift")
		var monthly = " (monthly)";
	else
		var monthly = "";
	
	jQuery(".ginput_total").html("$"+parseFloat(element.val()).toFixed(2) + monthly);
	jQuery(".ginput_container_total > input").val(element.val());
	jQuery(".ginput_container_product_price > input").val(element.val());
	
}

function dropBoxDelay(){
	
	selectIsOpen = true;
	
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

function setupTestimonialSliders() {
	
	jQuery('.testimonial_slider .slick').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 1,
		slidesPerRow: 1,
		dots: true,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 7000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false
	});
	
}

function setupFooterLogoRanch() {
	
	jQuery('#partner-logos').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: false,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: false,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		responsive: [
		{
		  breakpoint: 650,
		  settings: {
			slidesToShow: 3,
			slidesPerRow: 3,
		  }
		},
		{
		  breakpoint: 500,
		  settings: {
			slidesToShow: 2,
			slidesPerRow: 2,
		  }
		}
	  ]
	});
	
}
